export function toQueryString (object) {
  return Object.keys(object).map((key) => {
    if (object[key] != null) {
      if (typeof object[key] === 'object') {
        let aResult = []
        for (let i = 0; i < object[key].length; i++) {
          aResult.push(encodeURIComponent(key) + '=' + object[key][i])
        }
        return aResult.join('&')
      } else {
        return encodeURIComponent(key) + '=' + encodeURIComponent(object[key])
      }
    }
  }).join('&')
}



// WEBPACK FOOTER //
// ./src/filters/object.js